module.exports = __webpack_public_path__ + "img/伊藤裕人.f1f3d5a3.jpg";